import React from 'react';
import { motion } from 'framer-motion';
import { SEO } from '../../components/SEO';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { FadeIn } from '../../components/FadeIn';
import { AnimatedText } from '../../components/AnimatedText';
import { CommandCenter } from '../../components/CommandCenter';

const springConfig = {
  type: "spring",
  stiffness: 50,
  damping: 20,
  mass: 1
};

export const FinancialOptimization = () => {
  return (
    <div className="space-y-8">
      <SEO
        title="Financial Optimization | ProfitIQ.AI"
        description="Optimize your financial performance with AI-powered insights, cash flow forecasting, and automated financial health monitoring."
      />
      
      <Breadcrumbs
        items={[
          { label: 'Products', href: '/products' },
          { label: 'Financial Optimization' }
        ]}
      />

      <FadeIn>
        <AnimatedText
          text="AI-Powered Financial Optimization"
          el="h1"
          className="text-4xl font-bold mb-4 bg-gradient-to-r from-amber-200 to-amber-400 text-transparent bg-clip-text"
        />
        <p className="text-gray-400 text-lg mb-8">
          Make smarter financial decisions with real-time insights, predictive analytics, and AI-driven recommendations.
        </p>
      </FadeIn>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ...springConfig }}
      >
        <CommandCenter />
      </motion.div>
    </div>
  );
};